import React, { Component, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import CSVReader from "react-csv-reader";
import { getDirectusClient } from "../../../lib/directus";
import { Button, Modal, Space, Spin } from "antd";
import { createItem } from "@directus/sdk";

const Addfileproducts = (props) => {
  const fileselect = useRef();
  const [totalerrores, setTotalErrores] = useState(0);
  const [loanding, setLoanding] = useState(false);
  const [archivocargado, setArchivocargado] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [duplicateSerials, setDuplicateSerials] = useState([]);
  const papaparseOptions = {
    header: false,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
  };
console.log(props);

  useEffect(() => {
    if (props.modal == false) {
      fileselect.current.value = "";
    }
  }, [props.modal]);

  const handleForce = async (data, fileInfo) => {
    var largodedatos = data.length;
    var datoprocesados = 0;
    setLoanding(true);
    const directus = await getDirectusClient();
    const errores = [];
    const duplicateSerials = [];

    try {
      // Validate file size
      if (
        data.length > props.producto.cantidad ||
        data.length > props.producto.cantidad - (props.producto.seriales?.length || 0)
      ) {
        Modal.error({
          title: "Validación de tamaño de archivo",
          content: `El archivo contiene ${data.length} registros pero solo se pueden subir ${
            props.producto.cantidad - (props.producto.seriales?.length || 0)
          } registros`,
        });
        setLoanding(false);
        return;
      }

      const successfulSerials = [];
      
      // Process serials with Promise.all
      await Promise.all(
        data.map(async (serial) => {
          try {
            // Basic validation for serial format
            if (!serial[0]) {
              errores.push('Serial vacío');
              datoprocesados++;
              return;
            }

            // Create serial record
            await directus.request(
              createItem('seriales', {
                serial: serial[0],
                iccid: serial[1] || 0,
                min: serial[2] || 0,
                caja: serial[3] || 0,
                estado: 5,
                orden_compra_ingreso: props.order,
                producto: props.producto.producto_detalle.id,
                producto_odc: props.producto.id,
                bodega: props.bodegaId,
              })
            );
            
            successfulSerials.push(serial[0]);
            datoprocesados++;

          } catch (err) {
            if (err.errors?.[0]?.extensions?.code === "RECORD_NOT_UNIQUE") {
              errores.push(serial[0]);
              duplicateSerials.push(serial[0]);
            }
            datoprocesados++;
            console.error("Error al crear serial:", err);
          }
        })
      );

      // Update UI after processing
      setTotalErrores(errores.length);
      setLoanding(false);
      setArchivocargado(true);
      fileselect.current.value = "";
      setProcessingComplete(true);

      // Show appropriate message based on results
      if (errores.length === 0) {
        Modal.success({
          title: "Proceso completado exitosamente",
          content: (
            <div>
              <p>Se crearon {successfulSerials.length} seriales correctamente</p>
              <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                <ul>
                  {successfulSerials.map((serial, index) => (
                    <li key={index}>{serial}</li>
                  ))}
                </ul>
              </div>
            </div>
          )
        });
      } else {
        Modal.warning({
          title: "Proceso completado con advertencias",
          content: (
            <div>
              <p style={{ color: "green" }}>
                Se crearon correctamente: {successfulSerials.length} seriales
              </p>
              <p style={{ color: "red" }}>
                No se pudieron crear: {errores.length} seriales
              </p>
              <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                <p>Seriales duplicados o con error:</p>
                <ul>
                  {duplicateSerials.map((serial, index) => (
                    <li key={index}>{serial}</li>
                  ))}
                </ul>
              </div>
            </div>
          )
        });
      }

    } catch (error) {
      console.error('Error al procesar archivo:', error);
      setLoanding(false);
      Modal.error({
        title: "Error",
        content: "Error al procesar el archivo",
      });
    }
  };

  useEffect(() => {
    console.log("ingreso");
    setTotalErrores(0);
    setArchivocargado(false);
    fileselect.current.value = "";
  }, [props.producto]);

  const Error = (ev) => {
    console.log(ev);
  };
  return (
    <>
      {" "}
      <Space direction="vertical">
        <Space>
          <CSVReader
            ref={fileselect}
            cssClass="custom-file-input"
            label="
            Seleccionar archivo en Formato csv con las columnas SERIAL,ICCID,MIN,CAJA,GRUPO  separadas por (,)
             "
            onFileLoaded={handleForce}
            //onError={handleDarkSideForce}
            parserOptions={papaparseOptions}
            inputId="ObiWan"
            inputName="ObiWan"
            inputStyle={{ color: "#555" }}
          />
          <Button
            onClick={() => {
              fileselect.current.value = "";
            }}
          >
            reset
          </Button>
        </Space>
        <br></br>
        <Spin
          spinning={loanding}
          tip="Procesando Archivo por favor espere"
          size="large"
        >
          <div className="content" />
        </Spin>
        {processingComplete && (
          <>
            <p style={{ color: "green" }}>Se termino de procesar el archivo</p>
            {errorMessage && (
              <div style={{ color: "red" }}>
                <p>{errorMessage}</p>
                {duplicateSerials.length > 0 && (
                  <ul>
                    {duplicateSerials.map((serial, index) => (
                      <li key={index}>{serial}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </>
        )}
      </Space>
    </>
  );
};

export default Addfileproducts;
